module.exports = __webpack_public_path__ + "watermark.png?ec4a9f12c393b94bdb2963d9b86f8030";